import React from "react";
import DataService from "../../helpers/DataService";
import Utils from "../../helpers/Utils";
import _ from "lodash";
import Image from "../Image/Image";
import JwPlayer873 from "../Video/JwPlayer873";
import InformationAboutWork from "../InformationAboutWork/InformationAboutWork";
import CarouselControls from "../CarouselControls/CarouselControls";
import OpenSeaDragonViewer from "../OpenSeaDragon/OpenSeaDragonViewer";
import MoreInformation from "../MoreInformation/MoreInformation";

class Carousel extends React.Component {
  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._changePage = this._changePage.bind(this);

    this.state = {
      info: {},
      imgSrc: "",
      imgSrcBigMax: "",
      imgSrcDownload: "",
      modalOpen: false,
      seaDragonInit: false,
      isMounted: false,
      artistLink: {},
      apiObjectError: false,
      isVersions: false,
      isSeries: false,
      versionsImages: [],
      multipleActive: false,
      multipleTotal: 0,
      multipleActiveSlide: 0,
      multipleArray: [],
      numberInSeries: 0,
      encyclopediaLinkHeading: "",
    };
  }

  lastItem = {};
  emptyObject = false;

  _toggleVersions = (e) => {
    e.preventDefault();
    const isActive = !this.state.multipleActive;

    this.setState(
      {
        multipleActive: isActive,
      },
      function () {
        if (isActive) {
          if (this.state.isVersions) {
            let activeSlide = this.props.viewItems[this.props.slide];
            const id = activeSlide["artifact.uuid"];
            DataService.getSingle(
              id,
              (jsonData) => {
                const versions = jsonData.media.pictures.map((p) => ({
                  ...activeSlide,
                  "artifact.uuid": this.props.item["artifact.uuid"],
                  "artifact.ingress.producer":
                    this.props.item["artifact.ingress.producer"],
                  "identifier.id": this.props.item["identifier.id"],
                  "artifact.hasChildren":
                    this.props.item["artifact.hasChildren"],
                  isSeries: false,
                  isVersions: true,
                  "artifact.defaultMediaIdentifier": p.identifier,
                }));
                this.props.setVersions(versions);
              },
              () => {
                this.setState({
                  apiObjectError: true,
                });
              }
            );
          } else if (this.state.isSeries) {
            this.props.setVersions(this.state.multipleArray);
          } else {
            this.props.setVersions([]);
          }
        } else {
          this.props.endVersions();
        }
      }
    );
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.searchHasNoHits;
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      apiObjectError: false,
    });

    if (newProps.searchHasNoHits) {
      newProps = this.props;
    } else {
      this._setupData(newProps);
    }
  }

  _setupData = (newProps) => {
    this.emptyObject = false;
    if (Utils.objects.isEmptyObject(newProps.item)) {
      this.emptyObject = true;
      this.setState({
        apiObjectError: true,
      });
    }

    if (!this.emptyObject) {
      const isVersions = newProps.item["artifact.pictureCount"] > 1;
      const isSeries =
        newProps.item["identifier.id"].includes("-") ||
        newProps.item["artifact.hasChildren"];
      var multipleTotal = 0;
      let multipleArray = [];
      let currentIndex = 0;

      if (isVersions) {
        multipleTotal = newProps.item["artifact.pictureCount"];
      }

      if (isSeries) {
        var seriesArr = [];
        var theId = newProps.item["identifier.id"];
        theId = theId.slice(0, theId.indexOf("-"));

        newProps.sourceItems.forEach(function (el) {
          var elId = el["identifier.id"];
          elId = elId.slice(0, elId.indexOf("-"));

          if (elId == theId) {
            el.isSeries = true;
            el.isVersions = false;
            seriesArr.push(el);
          }
        });

        seriesArr.sort((a, b) => {
          let idA = a["identifier.id"];
          let slicedA = idA.slice(idA.indexOf("-") + 1);
          let idB = b["identifier.id"];
          let slicedB = idB.slice(idB.indexOf("-") + 1);
          return slicedA - slicedB;
        });

        currentIndex = _.findIndex(seriesArr, (item) => {
          return item["identifier.id"] === newProps.item["identifier.id"];
        });

        multipleArray = seriesArr;
        multipleTotal = multipleArray.length;
      }

      this.setState({
        imgSrc: Utils.image.getUrl(newProps.item, 800),
        imgSrcBigMax: Utils.image.getUrl(newProps.item, 1200),
        imgSrcDownload: Utils.image.getUrlDownload(newProps.item, "max"),

        multipleActive: newProps.multipleActive,
        isVersions: isVersions,
        isSeries: isSeries,
        multipleTotal: multipleTotal,
        multipleArray: multipleArray,
        numberInSeries: currentIndex,
      });
      Utils.dom.setTitle(newProps);

      if (this.props.item !== newProps.item) {
        const id = newProps.item["artifact.uuid"];
        DataService.getSingle(
          id,
          (jsonData) => {
            this._setupArtist(jsonData, newProps.item);
          },
          (error) => {
            this.setState({
              apiObjectError: true,
            });
          }
        );
      }
    } else {
      this.viewItems = this.props.viewItems[0]
        ? [this.props.viewItems[0]]
        : this.viewItems;
      this.lastItem = this.props.item ? this.props.item : this.lastItem;
    }
  };

  _handleHitFromEncyclopediaApi = (
    firstName,
    lastName,
    artistName,
    artistData,
    json,
    encyclopediaLinkHeading
  ) => {
    var artistLink = this._getArtistLink(json, firstName, lastName, artistName);
    this.setState({
      info: artistData,
      artistLink: artistLink,
      encyclopediaLinkHeading: encyclopediaLinkHeading,
    });
  };

  _handleSuccessFromNkl = (
    formattedName,
    firstName,
    lastName,
    artistName,
    artistData,
    noContactText,
    jsonNkl
  ) => {
    if (jsonNkl !== undefined)
      this._handleHitFromEncyclopediaApi(
        firstName,
        lastName,
        artistName,
        artistData,
        jsonNkl,
        this.props.cmsData.nklText
      );
    // Store norske leksikon
    else
      DataService.getSnlData(
        formattedName,
        (jsonSnl) => {
          this._handleSuccessFromSnl(
            firstName,
            lastName,
            artistName,
            artistData,
            noContactText,
            jsonSnl
          );
        },
        (error) => {
          this._handleErrorFromEncyclopedia(artistData, noContactText);
        }
      );
  };

  _handleSuccessFromSnl = (
    firstName,
    lastName,
    artistName,
    artistData,
    noContactText,
    jsonSnl
  ) => {
    if (jsonSnl !== undefined)
      this._handleHitFromEncyclopediaApi(
        firstName,
        lastName,
        artistName,
        artistData,
        jsonSnl,
        this.props.cmsData.snlText
      );
    else this._handleErrorFromEncyclopedia(artistData, noContactText);
  };

  _handleErrorFromEncyclopedia = (artistData, noContactText) => {
    this.setState({
      artistLink: {
        name: noContactText,
        url: null,
      },
      info: artistData,
    });
  };

  _setupLinkToEncyclopedia = (
    formattedName,
    firstName,
    lastName,
    artistName,
    artistData,
    noContactText
  ) => {
    // Norsk kunstnerleksikon
    DataService.getNklData(
      formattedName,
      (jsonNkl) =>
        this._handleSuccessFromNkl(
          formattedName,
          firstName,
          lastName,
          artistName,
          artistData,
          noContactText,
          jsonNkl
        ),
      (error) => this._handleErrorFromEncyclopedia(artistData, noContactText)
    );
  };

  _setupArtist = (artistData, item) => {
    var artistName = item["artifact.ingress.producer"];

    if (!artistName || artistName.length === 0) {
      // We won't be getting any new info
      // for this work, clear the current info.
      this.setState({ info: {} });
      return;
    }

    var indexOfComma = artistName.indexOf(",");
    let formattedName = artistName;

    if (indexOfComma > -1) {
      var firstName = artistName.substr(indexOfComma + 2).trim(); // 2 is comma plus space
      var lastName = artistName.substr(0, indexOfComma).trim();

      formattedName = `${firstName} ${lastName}`;
    }

    this._setupLinkToEncyclopedia(
      formattedName,
      firstName,
      lastName,
      artistName,
      artistData,
      this.props.cmsData.noContactText
    );
  };

  _getArtistLink = (json, firstName, lastName, artistName) => {
    if (!json) return;

    var url = null;
    var name = this.props.cmsData.noInformationText;
    var nameFromService = json.title.toLowerCase();

    if (
      nameFromService.includes(firstName.toLowerCase()) &&
      nameFromService.includes(lastName.toLowerCase())
    ) {
      url = json.article_url;
      name = artistName;
    }

    return {
      name: name,
      url: url,
    };
  };

  openModal(e) {
    this.setState({
      modalOpen: true,
    });

    if (!this.state.seaDragonInit) {
      this.ocd.initSeaDragon();
      this.setState({ seaDragonInit: true });
    }
  }

  _closeModal(e) {
    this.setState({
      modalOpen: false,
    });
  }

  _changePage(page) {
    this.props.changeSlide(page);
  }

  componentDidUpdate() {
    if (!this.props.searchHasNoHits) {
      if (typeof this.ocd !== "undefined") {
        if (this.ocd.viewer) {
          this.ocd.viewer.goToPage(this.props.slide);
          this.ocd.viewer.tileSources = this._mapSeaDragonArray(
            !this.emptyObject ? this.props.viewItems : this.viewItems
          );
        }
      }
    }
  }

  componentDidMount() {
    document.addEventListener("keyup", this._handleKeyPress.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener("keypress", this._handleKeyPress);
  }

  getCurrentWorkToDisplay() {
    let typeOfWork = this.props.item["artifact.type"];
    if (typeOfWork === "Fineart") {
      return (
        <Image
          item={this.props.item}
          sourceItems={this.props.sourceItems}
          apiObjectError={this.state.apiObjectError}
        />
      );
    } else if (typeOfWork === "Video") {
      return (
        <JwPlayer873
          item={this.props.item}
          titleText={this.props.cmsData.titleText}
          artistText={this.props.cmsData.artistText}
          ariaLabelVideoPlayButtonText={
            this.props.cmsData.ariaLabelVideoPlayButtonText
          }
        />
      );
    }
  }

  isCurrentWorkAVideo() {
    return this.props.item["artifact.type"] !== "Video";
  }

  _mapSeaDragonArray(arr) {
    var newArr = arr.map((item, index) => {
      return {
        type: "image",
        buildPyramid: false,
        url: Utils.image.getUrlDownload(item, "max"),
        downloadUrl: Utils.image.getUrlDownload(item, "max"),
      };
    });
    return newArr;
  }

  _handleKeyPress(event) {
    var code = event.keyCode || event.which;
    if (code === 27 && this.state.modalOpen) {
      this._closeModal();
    }
  }

  render() {
    let item = this.props.item;

    if (this.emptyObject) item = this.lastItem;

    return (
      <div id="gallery-carousel" className="gallery-carousel">
        <div className="gallery-carousel-top">
          <div className="gallery-carousel-image-wrapper">
            {this.getCurrentWorkToDisplay()}

            <CarouselControls
              apiObjectError={this.state.apiObjectError}
              prevSlide={this.props.prevSlide}
              nextSlide={this.props.nextSlide}
              imgSrcDownload={this.state.imgSrcDownload}
              handleFullscreenClick={this.openModal}
              showDownloadButton={this.isCurrentWorkAVideo()}
              showFullScreenButton={this.isCurrentWorkAVideo()}
            />
          </div>

          <InformationAboutWork
            apiObjectError={this.state.apiObjectError}
            cmsData={this.props.cmsData}
            isVersions={this.state.isVersions}
            isSeries={this.state.isSeries}
            multipleActive={this.state.multipleActive}
            numberInSeries={this.state.numberInSeries}
            multipleTotal={this.state.multipleTotal}
            slide={this.props.slide}
            viewItems={this.props.viewItems}
            item={item}
            info={this.state.info}
            artistLink={this.state.artistLink}
            encyclopediaLinkHeading={this.state.encyclopediaLinkHeading}
            toggleVersions={this._toggleVersions}
          />
        </div>

        <div
          className={
            "slider-fullscreen " +
            (this.state.modalOpen ? "open" : "") +
            (this.state.searchHasNoHits ? " no-hits" : "")
          }
        >
          {this.state.imgSrc ? (
            <OpenSeaDragonViewer
              image={this.state.imgSrc}
              imgSrcBigMax={this.state.imgSrcBigMax}
              imgSrcDownload={this.state.imgSrcDownload}
              viewItems={this._mapSeaDragonArray(
                !this.emptyObject ? this.props.viewItems : this.viewItems
              )}
              slide={!this.emptyObject ? this.props.slide : 0}
              closeModal={this._closeModal}
              ref={(instance) => {
                this.ocd = instance;
              }}
              changePage={this._changePage}
            />
          ) : null}
        </div>

        <MoreInformation
          cmsData={this.props.cmsData}
          info={this.state.info}
          multipleActiveSlide={this.state.multipleActiveSlide}
        />
      </div>
    );
  }
}

export default Carousel;
